@if (tags()?.length > 1) {
  <span class="tiime-icon-container-badge">{{ tags()?.length }}</span>
}
<mat-icon data-cy="tag-list-icon" fontSet="fontastic" fontIcon="icon-user-tag-fontastic-18"></mat-icon>
